import { useEffect, useState } from 'react';

import { APP_URL, navAnchors } from '@marketing/data/nav';
import { LumeMark } from '@marketing/illustrations/LumeMark';

// ============================================================
// StickyNav — barra fixa com âncoras + IntersectionObserver
// ============================================================

export function StickyNav() {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    const sections = navAnchors
      .map((a) => document.getElementById(a.id))
      .filter((el): el is HTMLElement => Boolean(el));

    if (sections.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]) setActiveId(visible[0].target.id);
      },
      { rootMargin: '-30% 0px -55% 0px', threshold: [0.1, 0.3, 0.6] },
    );

    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <nav className="lume-nav" aria-label="Navegação institucional">
      <div className="lume-nav__inner">
        <a href="#top" className="lume-nav__brand" aria-label="Lume — voltar ao início">
          <LumeMark size={28} />
          <span aria-hidden="true">lume</span>
        </a>

        <ul className="lume-nav__links" role="list">
          {navAnchors.map((a) => (
            <li key={a.id}>
              <a
                href={a.href}
                className="lume-nav__link"
                aria-current={activeId === a.id ? 'true' : undefined}
              >
                {a.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href={APP_URL}
          className="lume-btn lume-btn--primary lume-btn--sm"
          aria-label="Acessar o aplicativo Lume"
        >
          Acessar app →
        </a>
      </div>
    </nav>
  );
}
